import axiosInstance from '../utils/axiosConfig';

export interface Partner {
  id?: number;
  name: string;
  business_types?: { id: number; name: string }[];
  business_type_ids?: number[];
}

export const listPartners = async () => {
  const { data } = await axiosInstance.get<any[]>('/api/v1/partners');
  return data.map(partner => ({
    ...partner,
    business_type_ids: Array.isArray(partner.business_type_ids)
      ? partner.business_type_ids.filter((v: any): v is number => typeof v === 'number')
      : [],
  }));
};

export const createPartner = async (payload: Partner) => {
  const { data } = await axiosInstance.post<Partner>('/api/v1/partners', payload);
  return data;
};

export const updatePartner = async (id: number, payload: Partner) => {
  const { data } = await axiosInstance.put<Partner>(`/api/v1/partners/${id}`, payload);
  return data;
};

export const deletePartner = async (id: number) => {
  await axiosInstance.delete(`/api/v1/partners/${id}`);
}; 